// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"243":"1c18e13f","756":"2deb7cd4"}[chunkId] + ".css";
};